module.exports = __webpack_public_path__ + "675244b6094687ca3dc2d2e0c832a5d9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/goldenegg/egg-0.png
// module id = 513
// module chunks = 0